import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * New pages should start at the top. Back/forward (POP) is left alone so pages that
 * remember their position — like the directory grid — can restore it themselves.
 */
export const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === "POP") return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, search, navigationType]);

  return null;
};
